<template>
  <div class="animated fadeIn dashboard">
    <b-tabs justified v-if="verIndicadores">
      <!-- :active="verDashboardIndicadores"  -->
      <b-tab title="Indicadores"
          v-if="verDashboardIndicadores"
          @click="tabClicked(0)">
        <b-row>
          <b-col sm="6" lg="4">
            <app-indicador-ventas-total
              ref="indicadorVentasTotal"
              :totalNegocio="true"
              :accesoActualizar="actualizarResultados">
            </app-indicador-ventas-total>
          </b-col>

          <b-col sm="6" lg="4">
            <app-indicador-rentabilidad-bruta-total
              ref="indicadorRentabilidadBrutaTotal"
              :totalNegocio="true"
              :accesoExportar="consultarPresupuestosRB"
              :accesoActualizar="actualizarResultados">
            </app-indicador-rentabilidad-bruta-total>
          </b-col>

          <b-col sm="6" lg="4">
            <app-indicador-rentabilidad-neta-total
              ref="indicadorRentabilidadNetaTotal"
              :totalNegocio="true">
            </app-indicador-rentabilidad-neta-total>
          </b-col>
        </b-row>

        <hr class="dashboard">
        
        <app-objetivos-mensuales 
          ref="objetivosMensuales"
          :consultarRentabilidadBrutaReal="true">
        </app-objetivos-mensuales>
      </b-tab>

      <!-- :active="!verDashboardIndicadores"  -->
      <b-tab title="Comercial" 
          @click="tabClicked(1)">
        <b-row>
          <b-col cols="12">
            <app-comercial
              ref="comercial">
            </app-comercial>
          </b-col>
        </b-row>
      </b-tab>

      <!-- v-if="verDashboardVentasTrimestral"  -->
      <b-tab title="Ventas" 
          @click="tabClicked(2)">
        <b-row>
          <b-col cols="12">
            <app-ventas-trimestral
              ref="ventaTrimestral">
            </app-ventas-trimestral>
          </b-col>
        </b-row>
      </b-tab>

      <!-- v-if="verDashboardCuentas"  -->
      <b-tab title="Clientes" 
          @click="tabClicked(3)">
        <b-row>
          <b-col cols="12">
            <app-cuentas
              ref="indicadoresClientes">
            </app-cuentas>
          </b-col>
        </b-row>
      </b-tab>

      <!-- v-if="verDashboardAdministracion"  -->
      <b-tab title="Administracion" 
          @click="tabClicked(4)">
        <b-row>
          <b-col cols="12">
            <app-administracion
              ref="indicadoresAdministracion">
            </app-administracion>
          </b-col>
        </b-row>
      </b-tab>

      <!-- v-if="verDashboardProduccion"  -->
      <b-tab title="Proveedores" 
          @click="tabClicked(5)">
        <b-row>
          <b-col cols="12">
            <app-produccion
              ref="indicadoresProveedores">
            </app-produccion>
          </b-col>
        </b-row>
      </b-tab>

      <b-tab title="R.N." 
          v-if="verDashboardRN" 
          @click="tabClicked(6)">
        <b-row>
          <b-col cols="12">
            <app-rentabilidad-neta
              ref="rentabilidadNeta">
            </app-rentabilidad-neta>
          </b-col>
        </b-row>
      </b-tab>

      <b-tab title="Histórico" 
          v-if="verDashboardHistoricos" 
          @click="tabClicked(7)">
        <b-row>
          <b-col cols="12">
            <app-historico
              ref="indicadoresHistorico">
            </app-historico>
          </b-col>
        </b-row>
      </b-tab>

      <b-tab title="Resultados" 
          v-if="verDashboardSocios" 
          @click="tabClicked(8)">
        <b-row>
          <b-col cols="12">
            <app-socios
              ref="indicadoresSocios">
            </app-socios>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import IndicadorRentabilidadBruta from './dashboard/IndicadorRentabilidadBruta';
import IndicadorRentabilidadBrutaTotal from './dashboard/IndicadorRentabilidadBruta';
import IndicadorRentabilidadNeta from './dashboard/IndicadorRentabilidadNeta';
import IndicadorRentabilidadNetaTotal from './dashboard/IndicadorRentabilidadNeta';
import IndicadorVentas from './dashboard/IndicadorVentas';
import IndicadorVentasTotal from './dashboard/IndicadorVentas';
import Comercial from './dashboard/Comercial';
import VentasTrimestral from './dashboard/VentasTrimestral';
import RentabilidadNeta from './dashboard/RentabilidadNeta';
import Administracion from './dashboard/Administracion';
import Cuentas from './dashboard/Cuentas';
import Produccion from './dashboard/Produccion';
import Historico from './dashboard/IndicadoresHistorico';
import Socios from './dashboard/Socios';
import ObjetivosMensuales from './dashboard/comercial/ObjetivosMensuales.vue';
import { VueSvgGauge } from 'vue-svg-gauge';

export default {
  name: 'dashboard',
  components: {
    // Pie,
    VueSvgGauge,
    appIndicadorRentabilidadBruta: IndicadorRentabilidadBruta,
    appIndicadorRentabilidadBrutaTotal: IndicadorRentabilidadBrutaTotal,
    appIndicadorRentabilidadNeta: IndicadorRentabilidadNeta,
    appIndicadorRentabilidadNetaTotal: IndicadorRentabilidadNetaTotal,
    appIndicadorVentas: IndicadorVentas,
    appIndicadorVentasTotal: IndicadorVentasTotal,
    appComercial: Comercial,
    appVentasTrimestral: VentasTrimestral,
    appRentabilidadNeta: RentabilidadNeta,
    appHistorico: Historico,
    appAdministracion: Administracion,
    appCuentas: Cuentas,
    appProduccion: Produccion,
    appSocios: Socios,
    appObjetivosMensuales: ObjetivosMensuales,
  },
  data() {
    return {
      // rojo: '#E46651',
      // verde: '#41B883',
      // amarillo: '#FAFA05',
      // rosa: '#FF0187',

      verIndicadores: true,

      verDashboardIndicadores: false,
      verDashboardRN: false,
      verDashboardHistoricos: false,
      verDashboardVentasTrimestral: false,
      verDashboardAdministracion: false,
      verDashboardCuentas: false,
      verDashboardProduccion: false,
      // verTotalNegocio: false,
      verDashboardSocios: false,
      consultarPresupuestosRB: false,
      actualizarResultados: false,

      tabs: [
        { id: 0, nombre: 'General', loaded: true },
        { id: 1, nombre: 'Comercial', loaded: false },
        { id: 2, nombre: 'Ventas', loaded: false },
        { id: 3, nombre: 'Clientes', loaded: false },
        { id: 4, nombre: 'Administracion', loaded: false },
        { id: 5, nombre: 'Proveedores', loaded: false },
        { id: 6, nombre: 'RentabilidadNeta', loaded: false },
        { id: 7, nombre: 'Historico', loaded: false },
        { id: 8, nombre: 'Socios', loaded: false },
      ]
    }
  },
  created() {
    this.verDashboardIndicadores = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardIndicadores'));
    this.verDashboardRN = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardRentabilidadNeta'));
    this.verDashboardHistoricos = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardHistorico'));
    this.verDashboardSocios = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardSocios'));

    // this.verDashboardVentasTrimestral = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardVentas'));
    // this.verDashboardCuentas = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardCuentas'));
    // this.verDashboardAdministracion = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardAdministracion'));
    // this.verDashboardProduccion = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardProduccion'));
    
    this.actualizarResultados = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardIndicadoresActualizarResultados'));
    this.consultarPresupuestosRB = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardIndicadorRBConsultarPresupuestos'));

    // if (this.verIndicadores && this.verDashboardIndicadores) {
    //   this.$store.dispatch('resultadosVentas/getIndicadorVentasTotal')
    //     .then(() => this.$refs.indicadorVentasTotal.getIndicador());

    //   this.$store.dispatch('resultadosRentabilidadNeta/inicializar')
    //     .then(() => this.$refs.indicadorRentabilidadNetaTotal.getIndicador());

    //   this.$store.dispatch('resultadosRentabilidadBruta/inicializar')
    //     .then(() => this.$refs.indicadorRentabilidadBrutaTotal.getIndicador());
    // } else {
    //   console.log('getIndicadoresComercial');
    //   console.log(this.$refs);

    //   this.$refs.comercial.getIndicadores();

    //   /* Actualizamos el estado */
    //   var tab = this.tabs.find(t => t.id == 1);
    //   if (tab) {
    //     tab.loaded = true;
    //   }
    // }
  },
  mounted() {
    if (this.verIndicadores && this.verDashboardIndicadores) {
      this.$store.dispatch('resultadosVentas/getIndicadorVentasTotal')
        .then(() => this.$refs.indicadorVentasTotal.getIndicador());

      this.$store.dispatch('resultadosRentabilidadNeta/inicializar')
        .then(() => this.$refs.indicadorRentabilidadNetaTotal.getIndicador());

      this.$store.dispatch('resultadosRentabilidadBruta/inicializar')
        .then(() => this.$refs.indicadorRentabilidadBrutaTotal.getIndicador());
      
      this.$refs.objetivosMensuales.getResultados();
    } else {
      this.$refs.comercial.getIndicadores(true);

      /* Actualizamos el estado */
      var tab = this.tabs.find(t => t.id == 1);
      if (tab) {
        tab.loaded = true;
      }
    }
  },
  beforeDestroy() {
    console.log('beforeDestroy');
    this.$store.dispatch('resultadosRentabilidadNeta/cancelarIndicadorRentabilidadNetaAnual');
    this.$store.dispatch('resultadosRentabilidadNeta/cancelarIndicadorRentabilidadNetaSemestral');
    this.$store.dispatch('resultadosRentabilidadNeta/cancelarIndicadorRentabilidadNetaAnualTotal');
    this.$store.dispatch('resultadosRentabilidadNeta/cancelarIndicadorRentabilidadNetaSemestralTotal');
  },   
  methods: {
    tabClicked(e) {
      // console.log(e);

      let tabIndex = parseInt(e);

      var tab = this.tabs.find(t => t.id == tabIndex);
      if (tab) {
        if (!(/true/i).test(tab.loaded)) {
          switch (tab.id) {
            case 1: /* Comercial */
              if (this.getResultadosComercial()) {
                tab.loaded = true;
              }
              break;

            case 2: /* Ventas */
              if (this.getResultadosVentas()) {
                tab.loaded = true;
              }
              break;

            case 3: /* Clientes */
              if (this.getResultadosClientes()) {
                tab.loaded = true;
              }
              break;

            case 4: /* Administracion */
              if (this.getResultadosAdministracion()) {
                tab.loaded = true;
              }
              break;

            case 5: /* Proveedores */
              if (this.getResultadosProveedores()) {
                tab.loaded = true;
              }
              break;

            case 6: /* Rentabilidad Neta */
              if (this.getResultadosRentabilidadNeta()) {
                tab.loaded = true;
              }
              break;
            
            case 7: /* Historico */
              if (this.getResultadosHistorico()) {
                tab.loaded = true;
              }
              break;
            
            case 8: /* Socios */
              if (this.getResultadosSocios()) {
                tab.loaded = true;
              }
              break;
          }
        }
      }
    },
    getResultadosComercial() {
      const incluirObjetivosMensuales = !this.verDashboardIndicadores;
      
      this.$refs.comercial.getIndicadores(incluirObjetivosMensuales);
      return true;
    },
    getResultadosVentas() {
      this.$refs.ventaTrimestral.getIndicadores();
      return true;
    },
    getResultadosRentabilidadNeta() {
      this.$store.dispatch('resultadosRentabilidadNeta/getIndicadorRentabilidadNetaSemestralTotal')
        .then(() => {
          this.$refs.rentabilidadNeta.actualizarIndicadorSemestralTotal(this.$store.getters['resultadosRentabilidadNeta/indicadorRentabilidadNetaSemestralTotal']);
        })

      this.$store.dispatch('resultadosRentabilidadNeta/getIndicadorRentabilidadNetaAnualTotal')
        .then(() => {
          this.$refs.rentabilidadNeta.actualizarIndicadorAnualTotal(this.$store.getters['resultadosRentabilidadNeta/indicadorRentabilidadNetaAnualTotal']);
        })

      this.$store.dispatch('resultadosRentabilidadNeta/getIndicadorRentabilidadNetaSemestral')
        .then(() => {
          this.$refs.rentabilidadNeta.actualizarIndicadorSemestral(this.$store.getters['resultadosRentabilidadNeta/indicadorRentabilidadNetaSemestral']);
        })

      this.$store.dispatch('resultadosRentabilidadNeta/getIndicadorRentabilidadNetaAnual')
        .then(() => {
          this.$refs.rentabilidadNeta.actualizarIndicadorAnual(this.$store.getters['resultadosRentabilidadNeta/indicadorRentabilidadNetaAnual']);
        })
        
      return true;
    },
    getResultadosHistorico() {
      this.$refs.indicadoresHistorico.getIndicadores();
      return true;
    },
    getResultadosClientes() {
      this.$refs.indicadoresClientes.getIndicadores();
      return true;
    },
    getResultadosAdministracion() {
      this.$refs.indicadoresAdministracion.getIndicadores();
      return true;
    },
    getResultadosProveedores() {
      this.$refs.indicadoresProveedores.getIndicadores();
      return true;
    },
    getResultadosSocios() {
      this.$refs.indicadoresSocios.getIndicadores();
      return true;
    },
  }
}
</script>

<style>
  .dashboard .tabs {
    margin-bottom: 30px;
  }
  .dashboard .tab-pane {
    min-height: calc(100vh - 250px);
    padding-top: 25px;
    /* padding-bottom: 50px; */
  }
  .dashboard-chart {
    /* border: 1px solid red; */
    text-align: center;
    margin-bottom: 15px;
    padding: 15px 35px;
  }
  .dashboard-chart h4 {
    margin-bottom: 15px;
  }
  .dashboard-chart h4.titulo {
    margin-bottom: 5px;
  }
  .dashboard-chart p.subtitulo {
    margin-bottom: 10px;
    font-style: italic;
  }
  .dashboard-chart div.gauge {
    padding-left: 15%;
    padding-right: 15%;
    padding-top: 10px;
    padding-bottom: 15px;
  }
  .dashboard-chart-text {
    margin-top: 10px;
    padding: 10px;
    padding-left: 15%;
    text-align: left;
  }
  .dashboard-chart-text p {
    /* font-size: 0.8em; */
    margin-bottom: 5px;
  }
  .dashboard-chart-text p.description {
    font-size: 0.8em;
    font-style: italic;
  }
  .dashboard-chart-text p.link {
    font-size: 0.8em;
    font-style: italic;
    cursor: pointer;
  }
  .dashboard-chart-text p.link i {
    margin-right: 5px;
  }
</style>
